const encode = window.encodeURIComponent;

function stringifyKey(value: any, prefix: string, key: string, result: string[]) {
  if (value === undefined) return;
  if (value === null) value = '';
  const resultKey = prefix ? `${prefix}[${key}]` : '' + key;
  if (Array.isArray(value) || typeof value === 'object') return stringifyParams(value, result, resultKey);
  result.push(`${encode(resultKey)}=${encode(value)}`)
}

function stringifyParams(obj: any, result: string[], prefix = ''): void {
  const objType = typeof obj;
  if (Array.isArray(obj)) {
    obj.forEach((value, i) => {
      stringifyKey(value, prefix, i + '', result);

    })
  } else if (objType === 'object' && obj !== null) {
    for (let key in obj) {
      if (!obj.hasOwnProperty(key)) continue;
      stringifyKey(obj[key], prefix, key, result);
    }
  }
}

export function stringify(obj: any): string {
  const result: string[] = [];
  stringifyParams(obj, result);
  return result.join('&');
}
